import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'react-bootstrap'

import ContentItemSelectionMessage from './ContentItemSelectionMessage'
import ContentItemSelectionTopicBox from './ContentItemSelectionTopicBox'

class ContentItemSelection extends React.Component {
  constructor({ coursenum, groups, chapters, acceptMultiple=false, ...props}) {
    super({ coursenum, groups, chapters, acceptMultiple, ...props})
    this.state = {
      groups,
      chapters,
    }
  }

  static propTypes = {
    coursenum: PropTypes.string.isRequired,
    groups: PropTypes.array.isRequired,
    chapters: PropTypes.array.isRequired,
    acceptMultiple: PropTypes.bool,
  }

  updateGroup = groupData => {
    let groups = this.state.groups
    let index = groups.findIndex(function (group) {
      return groupData.pk === group.pk
    })
    groups[index] = groupData
    this.setState({ groups: groups })
  }

  updateChapters = chapterData => {
    let chapters = this.state.chapters
    let index = chapters.findIndex(function (chapter) {
      return chapterData.pk === chapter.pk
    })
    chapters[index] = chapterData
    this.setState({ chapters: chapters })
  }

  _handleSubmit = () => {
    const groupCounts = this.state.groups.map(
      group => group.items.filter(item => item.selected).length
    )
    const chapterCounts = this.state.chapters.map(
      chapterGroup => chapterGroup.items.filter(item => item.selected).length
    )
    const selectedCount =
      groupCounts.reduce((acc, cur) => acc + cur) +
      chapterCounts.reduce((acc, cur) => acc + cur)
    if (!this.props.acceptMultiple && selectedCount > 1) {
      $.meDialog.topMessage(
        'Please select a single item to import. The system you are using <br>' +
          'does not support importing multiple items at a time.',
        25000,
        'warning'
      )
      return
    }
    let chapterPks = this.state.chapters[0].items
      .filter(chapter => chapter.selected === true)
      .map(chapter => chapter.pk)
    let data = { activities: this.state.groups, chapters: chapterPks }
    this.props.handleSubmit(data)
  }

  render() {
    const btnText = this.props.acceptMultiple ? 'Import Items' : 'Import Item'

    let chapterObj = this.state.chapters[0]
    return (
      <div className="d-flex justify-content-center">
        <div>
          <ContentItemSelectionMessage
            acceptMultiple={this.props.acceptMultiple}
          />
          <h2 className="success-header pt-0 fs-xxl ml-5">Reading Content</h2>
          <ContentItemSelectionTopicBox
            group={chapterObj}
            acceptMultiple={this.props.acceptMultiple}
            updateGroupFunc={this.updateChapters}
          />
          <hr />
          <h2 className="success-header pt-0 fs-xxl ml-5">
            Assessment Content
          </h2>
          {this.state.groups.map(group => (
            <div key={group.pk}>
              {group.items.length !== 0 ? (
                <ContentItemSelectionTopicBox
                  group={group}
                  acceptMultiple={this.props.acceptMultiple}
                  updateGroupFunc={this.updateGroup}
                />
              ) : (
                <div />
              )}
            </div>
          ))}
          <div className="d-flex">
            <Button
              className="btn-block"
              variant="primary"
              onClick={this._handleSubmit}
            >
              {btnText}
            </Button>
          </div>
        </div>
      </div>
    )
  }
}

ContentItemSelection.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
}

export default ContentItemSelection
